export enum device_type {
  mobile,
  pc,
  api,
}
